var map = {
	"./archive.png": 1620,
	"./archive_burk.png": 702,
	"./archive_noah.png": 9119,
	"./archive_tobi.png": 3207,
	"./first.png": 6329,
	"./first_burk.png": 3326,
	"./first_noah.png": 5053,
	"./first_tobi.png": 4551,
	"./last.png": 3559,
	"./last_burk.png": 4030,
	"./last_noah.png": 5670,
	"./last_tobi.png": 4597,
	"./left_spacer.png": 7287,
	"./left_spacer_burk.png": 1529,
	"./left_spacer_noah.png": 2021,
	"./left_spacer_tobi.png": 1850,
	"./mid_spacer.png": 3269,
	"./mid_spacer_burk.png": 6612,
	"./mid_spacer_noah.png": 3880,
	"./mid_spacer_tobi.png": 829,
	"./next.png": 7114,
	"./next_burk.png": 8257,
	"./next_noah.png": 6310,
	"./next_tobi.png": 9939,
	"./prev.png": 5632,
	"./prev_burk.png": 2882,
	"./prev_noah.png": 8266,
	"./prev_tobi.png": 4168,
	"./right_spacer.png": 8978,
	"./right_spacer_burk.png": 8968,
	"./right_spacer_noah.png": 9504,
	"./right_spacer_tobi.png": 7928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1562;